import * as React from "react"
import {
  getAzureApiManagementClient,
  getSharedMppCloudClient,
} from "../../../api/client"
import { ContactFormApi } from "../../../api/services/contactForm"
import { OtpApi } from "../../../api/services/otp"
import { SendEmailApi } from "../../../api/services/sendEmail"
import { VerifyReCaptchaApi } from "../../../api/services/verifyReCaptcha"

type ApiProviderProps = { children: React.ReactNode }
export interface ApiContextInterface {
  sendEmailApi: SendEmailApi
  verifyReCaptchaApi: VerifyReCaptchaApi
  contactFormApi: ContactFormApi
  otpApi: OtpApi
}
const ApiContext = React.createContext<ApiContextInterface | null>(null)

const ApiProvider = ({ children }: ApiProviderProps) => {
  const azureApimClient = getAzureApiManagementClient()
  const mppCloudClient = getSharedMppCloudClient()
  const sendEmailApi = new SendEmailApi(azureApimClient)
  const verifyReCaptchaApi = new VerifyReCaptchaApi(azureApimClient)
  const contactFormApi = new ContactFormApi(mppCloudClient)
  const otpApi = new OtpApi(mppCloudClient)
  const value = { sendEmailApi, verifyReCaptchaApi, contactFormApi, otpApi }
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>
}

export { ApiProvider, ApiContext }
